import { computed } from 'vue'

import store from '@/store'
import { DEFAULT_FONT_SIZE, DEFAULT_LINE_HEIGHT, MAX_FONT_SIZE, MAX_LINE_HEIGHT, MIN_FONT_SIZE, MIN_LINE_HEIGHT } from '@/util/FontUtil'

const font = computed<string | undefined>(() => {
  return store.getters.user.userFont
})

const lineHeight = computed<number>(() => {
  return store.getters.user.userLineHeight || DEFAULT_LINE_HEIGHT
})

const fontSize = computed<number>(() => {
  return store.getters.user.userFontSize || DEFAULT_FONT_SIZE
})

const useFont = () => {
  return {
    MAX_FONT_SIZE,
    MAX_LINE_HEIGHT,
    MIN_FONT_SIZE,
    MIN_LINE_HEIGHT,
    font,
    fontSize,
    lineHeight,
  }
}

export { useFont }
